const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const log = require('log').create('nav link') // eslint-disable-line

function NavLink(props, context) {
    const { condition, onClick, className, href } = props
    if (! condition) return null

    const { pathname } = context.router.location

    // if current pathname matches the href, mark this link as active
    const active = (
        pathname === href
        || pathname.indexOf(`${href}/`) === 0
    )

    const classes = classNames('navlink', className, {
        active,
    })

    // wrapping link content in a span, which is used for focus rings
    return (
        <li className={classes}>
            <a
                href={href}
                onClick={onClick}
                data-metric-channel={props['data-metric-channel']}
                data-metric-event={props['data-metric-event']}
                >
                <span>{props.children}</span>
            </a>
        </li>
    )
}

NavLink.propTypes = {
    'onClick': PropTypes.func,
    'className': PropTypes.string,
    'children': PropTypes.any,
    'condition': PropTypes.bool,
    'href': PropTypes.string,
    'data-metric-channel': PropTypes.string,
    'data-metric-event': PropTypes.string,
}

NavLink.contextTypes = {
    router: PropTypes.shape({
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }),
    }).isRequired,
}

NavLink.defaultProps = {
    condition: true,
}

module.exports = NavLink
